import React, { Component } from 'react';
// import * as _ from 'lodash'
import './style.css';

import State from '../State'
import Logic from '../Logic'

class ResultHeader extends Component {

  handleSeeResultMoreDetailClick() {
    State.action('showResultPopup')
  }

  getBalanceText = {
    'ok': 'In balance',
    'poob': 'Possibly out of balance',
    'oob': 'Out of balance'
  }

  render() {

    if(!State.ui.explore) {
      return <div>Hello</div>
    }

    let originalBalance = Logic.getBalance(State.survey, 'originalChosenAnswer')
    let originalBalanceText = this.getBalanceText[originalBalance]
    let originalBalanceImage = `./img/results/${originalBalance}.png`
    let originalRotate = Logic.getImageRotation(State.survey, 'originalChosenAnswer')

    let balance = Logic.getBalance(State.survey, 'chosenAnswer')
    let balanceText = this.getBalanceText[balance]
    let balanceImage = `./img/results/${balance}.png`
    let balanceRotate = Logic.getImageRotation(State.survey, 'chosenAnswer')

    // let score = Logic.getTotalScore(State.survey, 'chosenAnswer')

    // <div className="label">Your new result ({score.toFixed(2)})</div>
    // <div className="footnote">(* indicates your original answers)</div>
    return (
      <div>
        <div className="result-header-section">
          <div className="label">Your original result</div>
          <div className="result">{originalBalanceText}</div>
          <div className="result-image"><img src={originalBalanceImage} alt={originalBalanceText} style={{transform: `rotate(${originalRotate}deg)`}} /></div>
        </div>
        <div className="result-header-section">
          <div className="label">Your new result</div>
          <div className="result">{balanceText}</div>
          <div className="button" onClick={this.handleSeeResultMoreDetailClick}>See your result in more detail</div>
          <div className="result-image"><img src={balanceImage} alt={balanceText} style={{transform: `rotate(${balanceRotate}deg)`}} /></div>
        </div>
      </div>
    );
  }
}

export default ResultHeader;



// WEBPACK FOOTER //
// ./src/ResultHeader/index.js